export default __webpack_public_path__ + "static/media/kitten.af5d4d2e.gif";